<script lang="ts" setup>
import { ref, inject, watch } from 'vue';

import type { Ref } from 'vue';
import type { Viewer } from '@immersive-tech/viewer-engine';
import type { IManifest } from '@/types/IManifest';

const viewer = inject('viewer') as Ref<Viewer>;
const manifest = inject('manifest') as Ref<IManifest>;
const envMapRotation = ref(90);

const degreesToRadians = (degrees: number) => {
  return (degrees * Math.PI) / 180;
};

const radiansToDegrees = (radians: number) => {
  return (radians * 180) / Math.PI;
};

const manifestWatcher = (newValue: IManifest) => {
  envMapRotation.value = radiansToDegrees(newValue.envMapRotation);
};

const envMapRotationWatcher = (newValue: number, oldValue: number) => {
  if (newValue === oldValue) return;

  let radians = 0;

  if (isNaN(newValue)) {
    radians = 0;
  } else if (newValue > 360) {
    radians = 360 * (Math.PI / 180);
  } else {
    radians = degreesToRadians(newValue);
  }

  manifest.value.envMapRotation = radians;
  viewer.value.environmentMapRotation = radians;
};

watch(manifest, manifestWatcher);
watch(envMapRotation, envMapRotationWatcher);
</script>

<template>
  <div class="flex flex-row items-center">
    <label for="envmap-rotation" class="text-xs mr-2">Rotation</label>
    <div class="border bg-white text-xs flex flex-row flex-grow items-center">
      <input
        id="envmap-rotation"
        v-model="envMapRotation"
        type="number"
        step="0.01"
        min="0"
        :max="360"
        class="p-1 text-xs flex-grow bg-transparent"
      >
      <p class="bg-transparent px-1">
        deg
      </p>
    </div>
  </div>
</template>
